import type { WorkOrderStatus } from '@api/work-order';
import SharedStatusPill, { type StatusTone } from '@components/ui/StatusPill';
import { type FC } from 'react';

/**
 * The work-order flavour of the shared pill.
 *
 * Only the mapping lives here now — what each status is called and what it means. The badge
 * itself moved to ui/StatusPill when the manufacturer portal needed the same thing for QC
 * verdicts, and a second copy would have drifted from this one.
 */
export const STATUS_LABEL: Record<string, string> = {
    DRAFT: 'Draft',
    ISSUED: 'Issued',
    IN_PRODUCTION: 'In Production',
    READY_TO_SHIP: 'Ready to Ship',
    SHIPPED: 'Shipped',
    RECEIVED: 'Received',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
};

const STATUS_TONE: Record<string, StatusTone> = {
    DRAFT: 'neutral',
    ISSUED: 'info',
    IN_PRODUCTION: 'warning',
    READY_TO_SHIP: 'info',
    SHIPPED: 'info',
    RECEIVED: 'positive',
    COMPLETED: 'positive',
    CANCELLED: 'critical',
};

const StatusPill: FC<{ status: WorkOrderStatus | string }> = ({ status }) => (
    <SharedStatusPill
        label={STATUS_LABEL[String(status)] ?? String(status)}
        tone={STATUS_TONE[String(status)] ?? 'neutral'}
    />
);

export default StatusPill;
